import axios from 'axios'
import moment from 'moment'
import numeral from 'numeral'
import Pikaday from 'pikaday'

export { axios, moment, numeral, Pikaday }